import { render, staticRenderFns } from "./AcessCollaboratorTable.vue?vue&type=template&id=31d4b410&scoped=true&"
import script from "./AcessCollaboratorTable.vue?vue&type=script&lang=js&"
export * from "./AcessCollaboratorTable.vue?vue&type=script&lang=js&"
import style0 from "./AcessCollaboratorTable.vue?vue&type=style&index=0&id=31d4b410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4b410",
  null
  
)

export default component.exports